<script setup>
import { swalError } from '@/helper';
import { create_report } from '@/services/report';
import { get_terms } from '@/services/terms';
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  report:{
    type: Object
  }
})

const store = useStore()
const extraTrait = ref(0)
const statusOption = ref([])
onMounted(async()=>{
  extraTrait.value = props.report.attributes.extra_trait | 0
  await getStatusOption()
})

const currentStatus = ref(null)
async function getStatusOption(){
  let response = await get_terms('report_status')
  if (!response.error){
    statusOption.value = response.result.data.data.map((term) => {
      return {
        id: term.id,
        label: term.attributes.name,
        active: false
      }
    })
    let temp = statusOption.value.find(item => item.label == props.report.attributes.status)
    // console.log("🚀 ~ getStatusOption ~ props.report.attributes.status:", props.report)
    // console.log("🚀 ~ getStatusOption ~ temp:", temp)
  }
}


const isLoading = ref(false)
async function saveChange(){
  isLoading.value = true
  let report = serializeForm()
  // console.log("🚀 ~ saveChange ~ report:", report)
  let response = await create_report(report)
  isLoading.value = false
  if (response.error){
    swalError(response.result.error, true)
    return
  }
  if (currentStatus.value != null){
    response.result.data.data.attributes.status = statusOption.value.find(item => item.id == currentStatus.value).label
  }
  store.dispatch('statistic/updateReport', {
    id: props.report.id, 
    attributes: response.result.data.data.attributes
  })
  Swal.fire({
    title: 'Updated',
    text: 'Change has been updated',
    icon: 'success'
  })
  document.getElementById('closeBtn_'+props.report.id).click()
}

function serializeForm(){
  let report = {
    id: props.report.id,
  }
  
  if (currentStatus.value != null){
    report.status = currentStatus.value
  }
  if (extraTrait.value != 0){
    report.extra_trait = extraTrait.value
  }
  return report
}
</script>
<template>
  <div :id="'report_' + report.id" class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit Report</h5>
        <button class="btn-close" type="button"
          data-bs-dismiss="modal" aria-label="Close"
        >
        </button>
      </div>
      <div class="modal-body">
        <div class="row mb-2">
          <div class="col-3 d-flex align-items-center">
            <p class="my-auto">Set Status : </p>
          </div>
          <div class="col-8">
            <multiselect 
              v-model="currentStatus" 
              placeholder="Select application status"
              :options="statusOption"
              valueProp="id"
              :searchable="true"
            ></multiselect>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-3 d-flex align-items-center">
            <p>Extra Trait : </p>
          </div>
          <div class="col-5">
            <input type="text" class="form-control" v-model="extraTrait" name="status" id="">
          </div>
        </div> -->
      </div>
      <div class="modal-footer">
        <button :id="'closeBtn_' + report.id" class="btn btn-light-danger" type="button" data-bs-dismiss="modal">Close</button>
        <button class="btn btn-light-success" type="button" @click="saveChange()">
          <div v-if="isLoading" class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <span v-else>Save changes</span>
        </button>
      </div>
    </div>
  </div>
</template>